import axios from "axios";
import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImCheckmark } from "react-icons/im";

import Swal from "sweetalert2";

import * as FaIcons from "react-icons/fa"; // Importa os ícones
import * as Fa6Icons from "react-icons/fa6";
import * as RiIcons from "react-icons/ri";
import * as LuIcons from "lucide-react";
import IconPicker from "./IconPicker"; // Importa o componente de seleção de ícones




const FormContainer = styled.form`
  width: auto;
  background-color: #fff;
  display: flex; 
  align-items: flex-end;
  gap: 5px;
  padding: 10px;
  margin-top: 30px;
  box-shadow: 0px 0px 2px #ccc;

`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 805px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;

  
`;

const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;

 
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; 
  padding-left: 1px;

  
`;

const Button = styled.button`
  padding: 0px 20px ;
  cursor: pointer;
  border-radius: 2px;
  border: none;
  background-color:  #fff;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  margin: 5px;
  color: #575757;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);

  }
`;


const Table = styled.table`
  width: 100%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;


`;

const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.3);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;

  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  
`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
 
`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;






const Form = ({ urlApi, modulos, fetchModulos }) => {

  //-------------------------------------------------------------------------------------------------//

  const ref = useRef();

  //-------------------------------------------------------------------------------------------------//

  const token = localStorage.getItem('token');


  //----------------------------------------STATES QUE CONTROLA A ESCOLHA DO ICONE---------------------------------------------------------//

  const [selectedIcon, setSelectedIcon] = useState(null); // Estado para armazenar o ícone escolhido
  const [showIconPicker, setShowIconPicker] = useState(false); // Controle do modal

  //----------------------------------------ONEDIT RESPONSAVEL POR EDITAR O MODULO---------------------------------------------------------//

  const [onEdit, setOnEdit] = useState(null);
  useEffect(() => {
    if (onEdit) {
      const user = ref.current;
      user.desc_modulo.value = onEdit.DESC_MODULO;
      setSelectedIcon(onEdit.ICONE);
    };
  }, [onEdit]);


  //onEdit para editar os modulo
  const handleEdit = (item) => {
    setOnEdit(item);
  };

  //----------------------------------------FUNÇÂO QUE SALVA POST/PUT---------------------------------------------------------//

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = ref.current;
    const desc_moduloValue = user.desc_modulo.value.trim();


    if (!desc_moduloValue || !selectedIcon) {
      return toast.warn("Preencha todos os campos!");
    }


    const moduloData = {
      desc_modulo: desc_moduloValue,
      icone: selectedIcon,
    };

    const url = onEdit
      ? `${urlApi}gestao/modulos/${onEdit.ID_MODULO}`
      : `${urlApi}gestao/modulos`;

    const method = onEdit ? "put" : "post";

    try {
      const response = await axios({
        method,
        url,
        data: moduloData,
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data);
      fetchModulos();

      // Resetando o formulário
      user.desc_modulo.value = "";
      setSelectedIcon("")
      setOnEdit(null);
    } catch (error) {
      let errorMessage = "Erro desconhecido";
      if (error.response) {
        errorMessage = error.response.data.error || errorMessage;

        toast.error("Erro ao adicionar: " + errorMessage);
      } else {
        console.error("Erro na solicitação:", error.message);
        toast.error("Erro na solicitação: " + error.message);
      }

    }
  };


  //----------------------------------------FUNÇÂO QUE DELETA O MODULO---------------------------------------------------------//

  //PopUp de confirmação para deletar
  const showPopUp = (detalhes) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de deletar esse módulo: ${detalhes}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };



  // Deleta os usuários
  const handleDelete = async (item) => {
    const detalhes = `${item.DESC_MODULO}`;
    const userConfirmed = await showPopUp(detalhes);

    if (!userConfirmed) return;

    try {
      const response = await axios.delete(`${urlApi}gestao/modulos/${item.ID_MODULO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data.message || "Módulo deletado com sucesso.");
      fetchModulos();
      setOnEdit(null);

    } catch (error) {
      console.error('Erro ao deletar o módulo:', error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Erro desconhecido ao deletar.';

      toast.error("Erro: " + errorMessage);
    }
  };




  //----------------------------------------MAPEA AS BIBLIOTECAS DE ICONES---------------------------------------------------------//


  const renderSelectedIcon = (iconName) => {
    const IconComponent = FaIcons[iconName] || Fa6Icons[iconName] || RiIcons[iconName] || LuIcons[iconName];
    if (IconComponent) {
      return <IconComponent size={24} />;
    } else {
      return <div>Ícone não encontrado</div>; // Caso o ícone não seja encontrado
    }
  };


  //-------------------------------------------------------------------------------------------------//

  return (
    <div>
      <FormContainer ref={ref} onSubmit={handleSubmit}>
        <InputArea>
          <Label>Crie um novo modulo:</Label>
          <Input name="desc_modulo" type="text" placeholder="Digite aqui..." />
        </InputArea>

        <Button type="button" onClick={() => setShowIconPicker(true)}>

          {selectedIcon ? (
            <>
              <span>Ícone escolhido:</span>
              <div>{renderSelectedIcon(selectedIcon)}</div>
            </>
          ) : (
            <span>Selecione um ícone:</span> // Caso nenhum ícone seja selecionado
          )}
        </Button>



        <ButtonContainer>
          <Button title="Salvar" type="submit">
            <ImCheckmark color={"green"} /> Salvar
          </Button>
        </ButtonContainer>
      </FormContainer>
      {showIconPicker && (
        <IconPicker
          onSelect={(icon) => {
            setSelectedIcon(icon);
            setShowIconPicker(false);
          }}
          onClose={() => setShowIconPicker(false)}
        />
      )}

      <Table >
        <Thead>

          <Tr>
            <Th>ID:</Th>
            <Th>Descrição</Th>
            <Th>Icone</Th>
            <Th></Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {modulos.map((item, i) => (
            <Tr key={i}>
              <Td width="auto">{item.ID_MODULO}</Td>
              <Td width="auto">{item.DESC_MODULO}</Td>
              <Td width="auto">{item.ICONE}</Td>

              <TdButton width="10%" onClick={() => handleEdit(item)}>
                Editar
              </TdButton>
              <TdButton width="10%" onClick={() => handleDelete(item)}>
                Deletar
              </TdButton>
            </Tr>
          ))}
        </Tbody>


      </Table>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


